// import PropTypes from 'prop-types';
import classNames from 'classnames';
import RawHtml from '../RawHtml/RawHtml';
import styles from './RichText.module.scss';
import { ucFirst } from '../../utils/caseconverters';

const RichText = ({ align = '', text, modifiers = [] }) => {
    const classes = classNames(
        styles['RichText'],
        styles['RichText--' + ucFirst(align)],
        modifiers.map((modifier) => styles['RichText--' + ucFirst(modifier)])
    );
    return (
        <div className={classes}>
            <div className={styles['RichText__Container']}>
                <RawHtml html={text} />
            </div>
        </div>
    );
};

RichText.propTypes = {};

export default RichText;
